var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M499 186l-105-81c-7-5-17-4-23 3l-80 106c-6 7-6 19 3 22 3 1 16-1 16-1 13-1 33-4 55-6v2c8 60-20 123-82 153-46 22-103 18-145-10-80-54-87-163-23-228 43-43 108-54 163-30 8 3 17 1 21-7l20-34c4-8 1-19-7-22C208 4 78 43 22 156c-34 69-28 153 15 216 44 65 113 98 182 98 56 0 112-22 155-64 49-50 70-118 61-184v-2c28-4 50-7 53-7 11-1 14-5 14-5 5-7 4-17-3-22" })
  );
});